export const isEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isValidatedCSV = (file) => {
  let maxSize = 10000000;

  return new Promise((resolve, reject) => {
    if (file.size < maxSize) {
      resolve(file);
    } else {
      reject({ type: "size", message: "File must be smaller than 10MB" });
    }
  });
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getColumns = (columns) =>
  columns.reduce((r) => {
    r = {
      columns,
      emailColumn: columns.find((c) => c.toLowerCase().includes("@")) || null,
      firstNameColumn: columns.find((c) => c.toLowerCase().includes("first")) || null,
      lastNameColumn: columns.find((c) => c.toLowerCase().includes("last")) || null,
      fullNameColumn:
        columns.find(
          (c) =>
            c.toLowerCase().includes("full") ||
            (c.toLowerCase().includes("name") &&
              !c.toLowerCase().includes("first") &&
              !c.toLowerCase().includes("last"))
        ) || null,
    };
    return r;
  }, {});

export const tabs = ["Approval Process", "Broker Upload", "Universal BCC"];

// export const content = {
//   approvedAgents: {
//     blast: "By default, all agents need approval to schedule an e- blast.For agents whom you want to skip approval process, please add them here.",
//     event: "By default, all agents need approval to schedule an event. For agents whom you want to skip approval process, please add them here."
//   },
//   approvers:{
//     blast:
//   }
// }
